import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import Header from "../Header";
import Footer from "../Footer";
import useRequests from "../../utils/useRequests";

const Page = () => {
  const { slug } = useParams(); // Get slug from URL
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { getRequest } = useRequests();

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await getRequest(`pages/${slug}`);
        console.log("Fetched Page data:", response); // Debug log

        if (response && response.data) {
          // Access the first element of the data array
          const { page_title = "", page_content = "" } = response.data;

          setPageData({ page_title, page_content });
        } else {
          console.error("Page not found!");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching page:", error);
        setLoading(false);
      }
    };

    fetchPageData();
  }, [slug]); // Re-run when slug changes

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%", // Ensure it takes full height
          minHeight: "300px", // Set a minimum height to avoid layout collapse
        }}
      >
        <CircularProgress color="primary" />
        <p>Loading ...</p>
      </Box>
    );
  if (!pageData) return <Typography>Page not found!</Typography>;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box
        className="center-App"
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Header name={pageData.page_title} />
        <Box
          sx={{
            padding: "15px",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >
          <Typography
            component="div"
            dangerouslySetInnerHTML={{ __html: pageData.page_content }}
          />
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default Page;
